import type { ReactElement } from 'react';
import { useState } from 'react';
import Collapse from 'react-bootstrap/Collapse';

type Props = {
  question: string;
  answer: string;
  expanded?: boolean;
};

function FAQ({ question, answer, expanded = false }: Props): ReactElement {
  const [collapsed, setCollapsed] = useState(!expanded);

  return (
    <div className="c-faqs__faq c-card">
      <div className="c-faqs__content">
        <h3>
          <button
            type="button"
            className={[
              'c-faqs__question',
              'c-link',
              collapsed ? 'collapsed' : '',
            ].join(' ')}
            aria-expanded={!collapsed}
            onClick={() => setCollapsed(!collapsed)}
          >
            {question}
            <span className="c-faqs__expand">+</span>
            <span className="c-faqs__collapse">-</span>
          </button>
        </h3>
        <Collapse in={!collapsed}>
          <div className="c-faqs__answer">
            {answer}
          </div>
        </Collapse>
      </div>
    </div>
  );
}

export default FAQ;
